import React from 'react';

import { ReactComponent as ChevronRight } from '../../assets/icons/icon_chevron_right.svg';
import { ReactComponent as ChevronLeft } from '../../assets/icons/icon_chevron_left.svg';

import ReactPagination from 'react-paginate';

interface Props {
    pageCount: number;
    currentPage: number;
    onPageChange: (page: number) => void;

    pageRangeDisplayed?: number;
}

const HanPagination: React.FC<Props> = ({ onPageChange, pageCount, currentPage, pageRangeDisplayed }) => {

    const onPaginationChange = (item: { selected: number }) => {
        if(item.selected < 0) return;

        onPageChange(item.selected + 1);
    };

    if(!pageCount) {
        return null;
    }

    return (
        <ReactPagination
            previousLabel={<ChevronLeft />}
            nextLabel={<ChevronRight />}
            breakLabel={'...'}
            initialPage={currentPage - 1}
            breakClassName={'break-me'}
            pageCount={pageCount}
            pageRangeDisplayed={5}
            marginPagesDisplayed={1}
            onPageChange={onPaginationChange}
            containerClassName={'han-pagination'}
            breakLinkClassName={'han-pagination__break'}
            activeClassName={'active'}
        />
    )
}

export default HanPagination;
